export const sharedTheme = {
  typography: {
    fontFamily: 'proxima-nova',
    h1: {
      fontSize: 25,
      fontWeight: 700,
    },
    h2: {
      fontSize: 22,
      fontWeight: 700,
    },
    h3: {
      fontSize: 18,
      fontWeight: 700,
    },
    h4: {
      fontSize: 16,
      fontWeight: 700,
    },
    h5: {
      fontSize: 14,
      fontWeight: 700,
    },
    body1: {
      fontSize: 16,
    },
    button: {
      fontSize: 16,
      fontWeight: 700,
      textTransform: 'none' as const,
    },
  },
  palette: {
    text: {
      secondary: '#434343',
      disabled: '#A6A6A6',
    },
    borders: {
      grey: '#E7E7E7',
      darkGrey: '#666565',
    },
    background: {
      grey: '#F5F6F7',
      lightBlue: '#F6FCFF',
      blue: '#A6D3E4',
    },
  },
}
